import { Core } from '@springtree/eva-services-core';
import buildServiceState from '../../builders/build-service-state.js';
const productDetailState = buildServiceState({
    allowEmptyRequest: false,
    key: 'productDetail',
    service: Core.GetProductDetail,
});
export default productDetailState;
//# sourceMappingURL=product-detail-state.js.map